<template>
  <div class="header p-l-0 p-r-0 bg-primary no-print">
    <div class="container bg-primary">
      <div class="header-inner header-md-height p-l-0 p-r-0">
        <div v-show="!notRequireLogin" class="text-white hand-pointer btn-link toggle-sidebar d-lg-none hidden-lg-up pg pg-menu" data-toggle="horizontal-menu"></div>
        <div class="">
          <router-link :class="{ disabled: isPending }" :to="{ name: 'Dashboard'}" class="inline brand no-border hidden-xs-down">
            <img src="../../assets/img/logo.png" alt="logo" width="78" height="22">
          </router-link>
        </div>
        <div class="d-flex align-items-center">
          <div v-if="!notRequireLogin" class="text-white pull-left fs-14 font-heading hidden-md-down">
            <current-user/>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="container">
        <div class="menu-bar header-sm-height" data-pages-init='horizontal-menu'>
          <a href="#" class="btn-link hidden-lg-up d-lg-none" data-toggle="horizontal-menu">
          </a>
          <i class="pg-close hidden-lg-up d-lg-none close-style" @click="closeSidebar"></i>
          <ul v-if="shouldDisplayMenu && !isPending">
            <li v-if="!isCandidate" @click="closeSidebar" :class="$route.name == 'Dashboard' ? 'active' : ''">
              <router-link :to="{ name: 'Dashboard'}">
                <img src="../../assets/img/logo-symbole.png" alt="logo" width="25"/>
              </router-link>
            </li>
            <li v-for="item in menuItems" :class="{ active: item.active, 'open opening': item.children }" @click="closeSidebar"
              @mouseover="showSubMenu(item)" @mouseleave="hideSubMenu(item)">
              <router-link :to="item.href">
                <span class="title">{{ item.name }}</span>
              </router-link>
              <ul v-if="item.children && isDisplay" @click="hideSubMenu(item)">
                <li v-for="child in item.children">
                  <router-link :to="child.href">{{ child.name }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="sub-menu hidden-lg-up d-lg-none">
            <li v-if="!isPending" @click="closeSidebar">
              <router-link :to="{ name: 'EditProfile' }">
                <span class="title">{{ $t("current_user.edit_profile") }}</span>
              </router-link>
            </li>
            <li @click="signOut">
              <a href="#"><span class="title">{{ $t("current_user.signout") }}</span></a>
            </li>
          </ul>
          <disturb-status v-if="isCandidate && !isPending"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentUser from './current_user'
import DisturbStatus from './DisturbStatus'
import { checkRoleManager, checkRoleCandidate } from '@/helpers/roles'
import { mapGetters } from 'vuex'
import { userStatus } from '@/settings/users'

export default {
  props: ["menuItems", "notRequireLogin"],
  components: {
    CurrentUser,
    DisturbStatus
  },
  data: function () {
    return ({
      isDisplay: false
    })
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    }),
    shouldDisplayMenu() {
      return !this.notRequireLogin
    },
    isCandidate(){
      return checkRoleCandidate(this.currentUser.role)
    },
    isPending() {
      return this.currentUser.state == userStatus.pending
    }
  },
  methods: {
    closeSidebar(){
      $('a[data-toggle="horizontal-menu"]').trigger('click');
    },
    signOut: function (){
      this.closeSidebar()
      this.$store.dispatch('auth/signOut')
      this.$router.replace({ path: '/users/signin' })
    },
    showSubMenu(item) {
      if (item.children) {
        this.isDisplay = true
      }
    },
    hideSubMenu(item) {
      if (item.children) {
        this.isDisplay = false
      }
    }
  },
  mounted: function(){
    window.Pages && window.Pages.initHorizontalMenu();
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/pages/_var.scss';

  .brand.inline {
    margin-left: 0!important;
  }

  .brand-name {
    color: $color-white;
    font-size: 24px;
    font-weight: 600;
  }

  .close-style {
    margin: 10px 18px;
    cursor: pointer;
    font-size: 24px;
  }

  .hand-pointer {
    cursor: pointer;
  }

  .disabled {
    pointer-events:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AppHeader.vue